import { useTabList } from '@react-aria/tabs'
import { useTabListState } from '@react-stately/tabs'

import { Tab } from './Tab'
import cx from 'classnames'
import Styles from './Tabs.module.scss'
import { useObjectRef } from 'utils/useObjectRef'
import { AriaTabListProps, SpectrumTabsProps } from '@react-types/tabs'

interface TabsProps extends SpectrumTabsProps<HTMLDivElement> {}

export const Tabs = (props: TabsProps) => {
  const state = useTabListState(props as AriaTabListProps<HTMLDivElement>)
  const ref = useObjectRef<HTMLDivElement>()
  const { tabListProps } = useTabList(props as AriaTabListProps<HTMLDivElement>, state, ref)
  const itemWithFraction = 100 / state.collection.size
  const translate = `-${itemWithFraction * (state.selectedItem?.index || 0)}%`

  return (
    <>
      <div {...tabListProps} ref={ref} className={Styles.tabsContainer}>
        <div className={Styles.tabs}>
          {[...state.collection].map((item, idx) => {
            const isSelected = state.selectedKey === item.key
            const isNextSelected = state.selectedKey === state.collection.at(idx + 1)?.key
            const isLastTab = idx === state.collection.size - 1

            return (
              <div className={Styles.tabItem} key={item.key}>
                <Tab key={item.key} item={item} state={state} />
                <div
                  className={cx(Styles.tabDivider, {
                    [Styles.hidden]: isSelected || isNextSelected || isLastTab,
                  })}
                />
              </div>
            )
          })}
        </div>
      </div>

      <div className={Styles.tabContentsContainer}>
        <div
          style={{
            width: `${100 * state.collection.size}%`,
            transform: `translateX(${translate})`,
          }}
          className={Styles.tabsContainerInner}
        >
          {[...state.collection].map((tab) => {
            return (
              <div className={Styles.tabContent} style={{ width: `${itemWithFraction}%` }} key={tab.key}>
                {state.selectedKey === tab.key && tab.props.children}
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
